import React from "react";
import symbolBlue from "@/assets/symbol_blue.png";
import symbolWhite from "@/assets/symbol_white.png";

export function Logo({ size = 40, light = false, className = "" }) {
  return (
    <img
      src={light ? symbolWhite : symbolBlue}
      alt="Terço dos Homens Mãe Rainha"
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size, objectFit: "contain" }}
      data-testid="brand-logo"
    />
  );
}

export function LogoWordmark({ light = false }) {
  const main = light ? "text-white" : "text-th-blue";
  const sub = light ? "text-th-goldlight" : "text-th-gold";
  return (
    <div className="flex items-center gap-3">
      <Logo size={44} light={light} />
      <div className="leading-none">
        <div className={`font-display font-bold text-[15px] tracking-wide ${main}`}>TERÇO DOS HOMENS</div>
        <div className={`font-display text-[10px] tracking-[0.25em] ${sub}`}>MÃE RAINHA · EUROPA</div>
      </div>
    </div>
  );
}
